import { useQuery } from "@tanstack/react-query";
import { getEarliestReviewDate } from "../../api/bReviewsApi";

/**
 * Hook to fetch the earliest review date for an organisation
 * Used to set the minimum date for date picker filters in Reviews pages
 * @param {string} organisationId - Required organisation ID
 */
export const useGetEarliestReviewDate = (organisationId, enabled = true) => {
  return useQuery({
    queryKey: ["earliest-review-date", organisationId],
    queryFn: () => getEarliestReviewDate(organisationId),
    enabled: !!organisationId && enabled,
    staleTime: 1000 * 60 * 5, // 5 minutes - earliest date rarely changes
    refetchOnWindowFocus: false,
  });
};
